@if (loading) {
  <div class="as-fixed-loader">
    <ng-lottie width="150px" height="150px" [options]="options"> </ng-lottie>
    <mat-label class="as-roboto-slab as-font-bold as-font-20 as-font-red">
      {{ 'GENERAL.loading' | translate }}...
    </mat-label>
  </div>
}
<div class="as-newsletter as-font-white">
  <div class="as-newsletter-background" [lazyLoad]="image">
    <div class="as-newsletter-content">
      <div class="as-newsletter-info">
        <mat-icon class="as-alsuper-logo" svgIcon="ic-alsuper-white"></mat-icon>
        <mat-label class="as-font-20 as-font-semibold">
          {{ 'FOOTER.subscribeToNewsletter' | translate }}
        </mat-label>
        <mat-label>
          {{ 'FOOTER.newsletterInfo' | translate }}
        </mat-label>
      </div>
      <form
        autocomplete="off"
        [formGroup]="newsLetterForm"
        class="as-newsletter-form"
        >
        <mat-form-field
          appearance="outline"
          color="accent"
          class="as-font mr-25"
          >
          <input
            formControlName="email"
            matInput
            placeholder="{{ 'AUTH.email' | translate }}"
            />
        </mat-form-field>
        <button
          [disabled]="newsLetterForm.invalid"
          (click)="subscribeNewsLetter()"
          mat-flat-button
          color="accent"
          >
          <mat-label class="as-font as-font-14 as-font-white">
            {{ 'GENERAL.subscribe' | translate }}
          </mat-label>
        </button>
      </form>
    </div>
  </div>
</div>
